<template>
  <vxe-modal
    ref="modal"
    v-model="formVisible"
    :title="`${DocumentStatus}报告审批`"
    width="80%"
    height="90%"
    @show="showModal"
  >
    <div class="formContainer">
      <div class="leftFormContainer">
        <el-form ref="FormRef" size="mini" :rules="rules" :model="form" :disabled="isDisabled">
          <el-row :gutter="10">
            <el-col :span="6">
              <el-form-item label="报告编号" prop="num">
                <el-input placeholder="输入" v-model="form.num" />
              </el-form-item>
            </el-col>

            <el-col :span="10">
              <el-form-item label="委托单位" prop="client">
                <!-- <el-input placeholder="输入" v-model="form.client" /> -->
                <el-autocomplete
                  v-model="form.client"
                  :fetch-suggestions="querySearchClient"
                  placeholder="输入"
                  clearable
                ></el-autocomplete>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="公司" prop="company">
                <el-select v-model="form.company" placeholder="选择">
                  <el-option label="中心" value="中心"></el-option>
                  <el-option label="公司" value="公司"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="申请人" prop="users_name">
                <el-input placeholder="关联" v-model="form.users_name" v-readonly> </el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="10">
            <el-col :span="6">
              <el-form-item label="申请日期" prop="apply_date">
                <el-date-picker
                  type="date"
                  placeholder="输入"
                  value-format="yyyy-MM-dd"
                  v-model="form.apply_date"
                ></el-date-picker>
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item label="是否邮寄" prop="is_mailed">
                <el-select clearable v-model="form.is_mailed" @change="mailedChange" placeholder="选择">
                  <el-option label="是" value="是"></el-option>
                  <el-option label="否" value="否"></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item label="是否盖章" prop="is_stamped">
                <el-select clearable v-model="form.is_stamped" placeholder="选择">
                  <el-option label="是" value="是"></el-option>
                  <el-option label="否" value="否"></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item label="是否到款" prop="is_payment_arrived">
                <el-input placeholder="关联" disabled v-model="form.is_payment_arrived" v-readonly> </el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="10">
            <el-col :span="24">
              <el-form-item label="说明" prop="memo">
                <el-input type="textarea" :rows="2" placeholder="输入" v-model="form.memo" />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="10" v-show="form.document_status >= 5">
            <el-col :span="24">
              <el-form-item label="财务审核意见" prop="financial_annotations">
                <el-input type="textarea" :rows="2" readonly v-model="form.financial_annotations" />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="10" v-show="form.document_status === 9">
            <el-col :span="24">
              <el-form-item label="领导审批意见" prop="approve_opinions">
                <el-input type="textarea" :rows="5" readonly v-model="form.approve_opinions" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>

        <div v-show="form.is_mailed === '是'">
          <!-- 明细table -->
          <div style="margin-bottom: 5px" v-if="!isDisabled">
            <el-button size="mini" type="primary" icon="el-icon-plus" @click="handleAdd">新增</el-button>
          </div>
          <vxe-grid
            ref="xTable"
            size="mini"
            :column-config="{ minWidth: '80px' }"
            :columns="tableColumns"
            border
            keep-source
            resizable
            :edit-rules="validRules"
            show-overflow
            :data="form.detailList"
            highlight-hover-row
            highlight-current-row
            :mouse-config="{ area: true, extension: true }"
            :edit-config="{ trigger: 'dblclick', mode: 'cell', activeMethod: activeMethod, showIcon: false }"
            :keyboard-config="{
              isArrow: true,
              isEnter: true,
              isTab: true,
              enterToTab: true,
              isClip: true,
              isEdit: true,
              editMethod: editMethod
            }"
            @cell-menu="cellContextMenuEvent"
            :menu-config="{ body: { options: bodyMenus }, visibleMethod: visibleMethod }"
            @menu-click="contextMenuClickEvent"
          >
          </vxe-grid>
        </div>
      </div>
      <div class="rightFormContainer">
        <FileList
          :ID="id"
          :isDisabled="isDisabled"
          @PreSignature="PreSignature"
          ref="FileListRef"
          vuePath="ReportApprove"
        />
      </div>
    </div>

    <DetailModalBtnVue
      ref="DetailModalBtnVueRef"
      menuPath="ReportApprove"
      :parentData="this"
      @handleClick="handleClickBtn"
    />

    <!-- 领导审核 -->
    <FastInputVue ref="FastInputVueRef" @sureBack="sureBackApprovalOpinions" />
    <!-- 财务审核 -->
    <ApproveOption ref="ApproveOptionRef" @sureBack="sureBackApprovalOpinions" />
    <!-- 日期输入框 -->
    <DateInput ref="DateInputRef" @sureHandler="sureBackDate" />

    <!-- 选择用户 -->
    <EmployeeSelect ref="EmployeeSelectRef" @sureBackPerson="sureBackPerson" :isMultiple="false" />

    <!-- 滚动条自定义右键 -->
    <MyContextMenu ref="MyContextMenuRef" @backContextMenu="contextMenuClickEvent" />
  </vxe-modal>
</template>
<script>
import FileList from '@/components/Form/FileList.vue'
import DetailModalBtnVue from '@/components/common/DetailModalBtn.vue'
import { getState } from '../../utils/state'
import FastInputVue from '../../components/Modal/FastInput/FastInput.vue'
import ApproveOption from '../../components/Modal/FastInput/ApproveOption.vue'
import EmployeeSelect from '../../components/Modal/Employee/EmployeeSelect.vue'
import MyContextMenu from '../../components/common/MyContextMenu.vue'

export default {
  components: {
    FileList,
    DetailModalBtnVue,
    FastInputVue,
    ApproveOption,
    EmployeeSelect,
    MyContextMenu
  },
  data() {
    return {
      id: -1,
      // 表单
      form: {
        id: 0,
        creator_id: 0,
        creator: '',
        createTime: '',
        num: '',
        client: '',
        users_name: '',
        apply_date: '',
        memo: '',
        company: '中心',
        document_status: 0,
        approve_opinions: '',
        financial_annotations: '',
        last_modify_time: '',
        is_mailed: '',
        is_stamped: '',
        is_payment_arrived: '',
        detailList: []
      },
      rules: {
        num: [
          { required: true, message: '请输入报告编号', trigger: 'change' },
          {
            min: 0,
            max: 32,
            message: '长度在 0 到 32 个字符',
            trigger: 'change'
          }
        ],
        client: [
          { required: true, message: '请输入委托单位', trigger: 'change' },
          {
            min: 0,
            max: 256,
            message: '长度在 0 到 256 个字符',
            trigger: 'change'
          }
        ],
        users_name: [],
        apply_date: [{ required: true, message: '请输入申请日期', trigger: 'change' }],
        memo: [
          {
            min: 0,
            max: 512,
            message: '长度在 0 到 512 个字符',
            trigger: 'change'
          }
        ],
        document_status: [],
        approve_opinions: [],
        financial_annotations: [],
        last_modify_time: []
      },
      // 下拉框
      ComBoxItems: {},
      formVisible: false,

      showMoney: true,
      // 是否禁用编辑
      isDisabled: false,
      // 校验规则
      validRules: {
        sender: [
          { required: true, message: '请选择寄件人', trigger: 'change' },
          {
            min: 0,
            max: 32,
            message: '长度在 0 到 32 个字符',
            trigger: 'change'
          }
        ],
        ship_date: [{ required: true, message: '请输入寄件日期', trigger: 'change' }],
        contribution_details: [
          { required: true, message: '请输入寄件内容', trigger: 'change' },
          {
            min: 0,
            max: 512,
            message: '长度在 0 到 512 个字符',
            trigger: 'change'
          }
        ],
        courier_company: [
          { required: true, message: '请输入快递公司', trigger: 'change' },
          {
            min: 0,
            max: 128,
            message: '长度在 0 到 128 个字符',
            trigger: 'change'
          }
        ],
        is_expedited: [],
        recipient: [
          { required: true, message: '请输入收件人', trigger: 'change' },
          {
            min: 0,
            max: 64,
            message: '长度在 0 到 64 个字符',
            trigger: 'change'
          }
        ],
        receiving_company: [
          { required: true, message: '请输入收件单位', trigger: 'change' },
          {
            min: 0,
            max: 128,
            message: '长度在 0 到 128 个字符',
            trigger: 'change'
          }
        ]
      },
      // 右键缓存
      areas: {},
      colProperty: '',
      bodyMenus: [],
      // 删除行缓存
      cacheRemoveRows: [],
      // 联想下拉集合
      combobox: {
        client: []
      }
    }
  },
  methods: {
    querySearchClient(queryString, cb) {
      const results = queryString
        ? this.combobox.client.filter(item => String(item.value).includes(queryString))
        : this.combobox.client
      // 调用 callback 返回建议列表的数据
      cb(results)
    },
    // 绑定下拉框
    async BindComBox() {
      this.combobox.client = []
      this.bodyMenus = [
        [
          {
            code: 'yesOrNo',
            name: '是'
          },
          {
            code: 'yesOrNo',
            name: '否'
          },
          {
            code: 'courier_company',
            name: '京东物流'
          },
          {
            code: 'courier_company',
            name: '顺丰速运'
          },
          {
            code: 'courier_company',
            name: '邮政快递'
          },
          {
            code: 'courier_company',
            name: '韵达快递'
          },
          {
            code: 'courier_company',
            name: '中通快递'
          },
          {
            code: 'courier_company',
            name: '圆通速递'
          },
          {
            code: 'courier_company',
            name: '申通快递'
          },
          {
            code: 'courier_company',
            name: '百世快递'
          }
        ]
      ]

      const { data: selectRes } = await this.$http.get('/Finance/Report_approve/select-item')
      if (selectRes.isSuccess) {
        for (let item of selectRes.data) {
          switch (item.code) {
            case 'client':
              this.combobox.client.push({
                label: item.name,
                value: item.value
              })
              break
            // 收件单位
            case 'receiving_company':
              this.bodyMenus[0].push({
                code: 'receiving_company',
                name: item.name
              })
              break
            default:
              if (item.comments === '收件人') {
                this.bodyMenus[0].push({
                  code: `recipient#@#${item.code}`,
                  name: item.name
                })
              }
              break
          }
        }
      }
    },
    // 是否邮寄变化时
    mailedChange(str) {
      this.$nextTick(() => {
        if (str === '是') {
          if (this.form.detailList.length <= 0) {
            this.form.detailList.push({
              sender: this.$store.state.userInfo.name,
              ship_date: this.ykDateFormat('yyyy-MM-dd', new Date()),
              is_expedited: '否',
              receiving_company: this.form.client,
              courier_company: ''
            })
          }
        }
      })
    },
    // cell激活控制
    activeMethod({ column }) {
      if (this.isDisabled) {
        return false
      }
      if (column.editRender && column.editRender.attrs && column.editRender.attrs.disabled === true) {
        return false
      }
      return true
    },
    // cell编辑控制
    editMethod({ row, column, $table }) {
      if (this.isDisabled) {
        return false
      }
      if (column.editRender && column.editRender.attrs && column.editRender.attrs.disabled === true) {
        return false
      }
      row[column.property] = null
      $table.setActiveCell(row, column.property)
      return true
    },

    // 按下右键缓存选中列
    cellContextMenuEvent({ column, row }, event) {
      this.areas = this.$refs.xTable.getCellAreas()
      this.colProperty = column.property

      if (!this.isDisabled && ['ship_date'].includes(column.property)) {
        this.$refs.DateInputRef.formVisible = true
      }

      if (!this.isDisabled && ['sender'].includes(column.property)) {
        this.$refs.EmployeeSelectRef.formVisible = true
      }

      // 收件单位 和 收件人用自定义右键
      if (column.property === 'receiving_company' || column.property === 'recipient') {
        let eve = event || window.event
        const x = eve.clientX
        const y = eve.clientY
        if (column.property === 'receiving_company') {
          this.$refs.MyContextMenuRef.options = this.bodyMenus[0].filter(item => {
            return item.code === 'receiving_company'
          })
        } else {
          this.$refs.MyContextMenuRef.options = this.bodyMenus[0].filter(item => {
            let visible = false

            if (row.receiving_company) {
              if (item.code.includes('recipient#@#')) {
                visible = item.code.split('#@#')[1] === row.receiving_company
              }
            } else {
              visible = item.code.includes('recipient#@#')
            }

            return visible
          })
        }
        this.$refs.MyContextMenuRef.mouseX = x
        this.$refs.MyContextMenuRef.mouseY = y
        this.$refs.MyContextMenuRef.disabled = this.isDisabled
        this.$refs.MyContextMenuRef.formVisible = true
        setTimeout(() => {
          this.$refs.MyContextMenuRef.setposition()
        }, 25)
      }
    },
    // 右键控制菜单方法
    visibleMethod({ options, column }) {
      // 显示之前处理按钮的操作权限
      options.forEach(list => {
        list.forEach(item => {
          item.disabled = this.isDisabled
          if (column) {
            switch (column.property) {
              case 'is_expedited':
                item.visible = item.code === 'yesOrNo'
                break
              case 'courier_company':
                item.visible = item.code === 'courier_company'
                break
              // case 'receiving_company':
              //   item.visible = item.code === 'receiving_company'
              //   break
              // case 'recipient':
              //   // 如果有收件单位的字段, 根据它过滤
              //   if (row.receiving_company) {
              //     let visible = false
              //     if (item.code.includes('recipient#@#')) {
              //       visible = item.code.split('#@#')[1] === row.receiving_company
              //     }
              //     item.visible = visible
              //   } else {
              //     item.visible = item.code.includes('recipient#@#')
              //   }
              //   break
              default:
                item.visible = false
                break
            }
          } else {
            item.visible = false
          }
        })
      })
      return true
    },
    // 右键确认
    contextMenuClickEvent({ menu }) {
      this.areas.forEach(area => {
        for (let row of area.rows) {
          for (let col of area.cols) {
            if (col.property === this.colProperty) {
              if (col.property === 'is_expedited') {
                if (menu.name === '清空') {
                  row['is_expedited'] = ''
                } else {
                  row['is_expedited'] = menu.name
                }
              } else if (col.property === 'courier_company') {
                if (menu.name === '清空') {
                  row['courier_company'] = ''
                } else {
                  row['courier_company'] = menu.name
                }
              } else if (col.property === 'receiving_company') {
                row['receiving_company'] = menu.name
                const filterItems = this.bodyMenus[0].filter(item => item.code === `recipient#@#${menu.name}`)
                // 如果没有收件人, 直接赋值
                if (filterItems.length === 1 && !row['recipient']) {
                  row['recipient'] = filterItems[0].name
                }
              } else if (col.property === 'recipient') {
                const receiving_company = menu.code.split('#@#')[1]
                if (row['receiving_company'] === receiving_company) {
                  // 有的话按照收件单位赋值
                  row['recipient'] = menu.name
                } else if (!row['receiving_company']) {
                  // 没有的话直接赋值
                  row['receiving_company'] = receiving_company
                  row['recipient'] = menu.name
                }
              }
            }
          }
        }
      })

      this.$refs.xTable.updateData()
    },
    // 日期返回
    sureBackDate(date) {
      this.areas.forEach(area => {
        for (let row of area.rows) {
          for (let col of area.cols) {
            if (col.property === this.colProperty) {
              row[this.colProperty] = date
            }
          }
        }
      })
    },
    // 新增明细
    handleAdd() {
      this.form.detailList.push({
        sender: this.$store.state.userInfo.name,
        ship_date: this.ykDateFormat('yyyy-MM-dd', new Date()),
        is_expedited: '否',
        courier_company: ''
      })
    },
    // 选择完成后
    sureBackPerson(person) {
      this.areas.forEach(area => {
        for (let row of area.rows) {
          for (let col of area.cols) {
            if (col.property === this.colProperty) {
              row[this.colProperty] = person
            }
          }
        }
      })
    },
    // 预签字
    async PreSignature() {
      const { data: res } = await this.$http.put(`/Finance/Report_approve/signature/${this.form.id}`)
      if (!res.isSuccess) {
        this.$message({
          type: 'warning',
          dangerouslyUseHTMLString: true,
          message: `<span>${res.errorMessage}</span><br />` + res.data.map(item => `&emsp;${item}`).join('<br />')
        })
      }
    },
    // 输入完意见
    async sureBackApprovalOpinions(options, type = '') {
      const flag = await this.sureReview(false, options)

      if (flag) {
        this.$message.success('操作成功!')

        this.$emit('updateData')
        this.BindText()

        if (type === 'fa') {
          this.$refs.ApproveOptionRef.closeModal()
        } else {
          this.$refs.FastInputVueRef.closeModal()
        }
      }
    },
    // 获取附件
    getFileList() {
      this.$refs.FileListRef.init()
    },
    // 领导/总经理审批
    refuse() {
      this.$confirm('是否确认拒绝?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const success = await this.sureObsolete()
        if (success) {
          this.$message.success('操作成功!')

          this.$emit('updateData')
          this.BindText()
        }
      })
    },
    // 领导/总经理审批
    leaderReview() {
      this.$confirm('是否确认审批通过?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const success = await this.sureReview()
        if (success) {
          this.$message.success('操作成功!')

          this.$emit('updateData')
          this.BindText()
        }
      })
    },
    // 取消审核
    unReview() {
      this.$confirm('是否确认取消?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const success = await this.sureUnReview()
        if (success) {
          this.$message.success('取消成功!')

          this.$emit('updateData')
          this.BindText()
        }
      })
    },
    // 调用审批接口
    async sureReview(flag = false, approve_opinions) {
      const approve_obj = typeof approve_opinions === 'string' ? { approve_opinions } : approve_opinions

      const { data: res } = await this.$http.put('/Finance/Report_approve/audit', [
        {
          id: this.id,
          manager_review: flag,
          ...approve_obj
        }
      ])
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }

      await this.getFileList() // 重新拉附件

      return true
    },
    // 调用撤销审核
    async sureUnReview(flag = false) {
      const { data: res } = await this.$http.put('/Finance/Report_approve/unaudit', [
        {
          id: this.id,
          manager_review: flag
        }
      ])
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }

      await this.getFileList() // 重新拉附件

      return true
    },
    // 调用拒绝接口
    async sureObsolete() {
      const { data: res } = await this.$http.put('/Finance/Report_approve/obsolete', [
        {
          id: this.id,
          manager_review: false
        }
      ])
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      return true
    },
    // 点击底部按钮
    handleClickBtn(code) {
      switch (code) {
        case 'save':
          this.save()
          break
        case 'del':
          this.del()
          break
        case 'unReview':
          this.unReview()
          break
        case 'faReview':
        case 'financialReview':
          this.$refs.ApproveOptionRef.openModal()
          break
        case 'managerReview':
        case 'leaderReview':
          // this.leaderReview()
          this.$refs.FastInputVueRef.openModal()
          break
        case 'refuse':
          this.refuse()
          break
        case 'close':
          this.formVisible = false
          break
      }
    },
    // 打开模态窗
    openModal(id = 0) {
      this.id = id

      if (!this.id) {
        this.form = {
          id: 0,
          creator_id: 0,
          creator: '',
          createTime: '',
          num: '',
          client: '',
          users_name: '',
          company: '中心',
          apply_date: '',
          memo: '',
          document_status: 0,
          approve_opinions: '',
          financial_annotations: '',
          last_modify_time: '',
          is_mailed: '',
          is_stamped: '',
          is_payment_arrived: '',
          detailList: []
        }
      }

      this.BindComBox()

      this.$nextTick(() => {
        this.formVisible = true
      })
    },
    async validEnter() {
      const that = this
      let flag = true
      await that.$refs.FormRef.validate().then(
        res => {
          flag = res
        },
        err => {
          flag = err
        }
      )

      that.errIndex = []
      that.removeEmptyForTable(that.$refs.xTable)
      const errMap = await that.$refs.xTable.fullValidate(true).catch(errMap => errMap)
      if (errMap) {
        Object.values(errMap).forEach(errList => {
          errList.forEach(params => {
            let { row, column, rules } = params
            rules.forEach(() => {
              that.errIndex.push({
                _XID: row._XID,
                property: column.property
              })
            })
          })
        })
        if (that.errIndex.length > 0) {
          flag = false
        }
      }

      if (!flag) {
        that.$message.error('验证失败,请核对输入数据')
      }
      return flag
    },
    // 保存
    save() {
      this.validEnter().then(async result => {
        if (result) {
          if (this.id && this.id > 0) {
            this.update()
          } else {
            this.add()
          }
        }
      })
    },
    // 获取数据
    async BindText() {
      const that = this
      if (that.id > 0) {
        const { data: res } = await that.$http.get('/Finance/Report_approve', {
          params: {
            id: that.id
          }
        })
        if (res.isSuccess) {
          that.form = res.data
        }
      } else {
        this.form.apply_date = this.ykDateFormat('yyyy-MM-dd', new Date())
        // 用户信息赋值
        this.form.users_name = this.$store.state.userInfo.name

        this.form.creator_id = this.$store.state.userInfo.userId
        this.form.creator = this.$store.state.userInfo.name
        this.form.createTime = this.ykDateFormat('yyyy-MM-dd HH:mm:ss', new Date())
      }
      that.$nextTick(() => {
        that.$refs.FormRef.clearValidate()

        if (this.form.document_status !== 0 || this.form.creator_id !== this.$store.state.userInfo.userId) {
          this.isDisabled = true
        } else {
          this.isDisabled = false
        }
      })
    },
    hasPDFFileName(fileNames) {
      const pdfExtension = '.pdf'
      return fileNames.some(fileName => fileName.toLowerCase().endsWith(pdfExtension))
    },
    // 新增
    async add() {
      const that = this

      const fileList = this.$refs.FileListRef.getCacheFileList()

      const fileNames = fileList.map(item => item.name)

      const containsPDF = this.hasPDFFileName(fileNames)

      // 如果文件中没有pdf
      if (!containsPDF) {
        this.$message.error('报告中必须含有一个PDF文件!')
        return
      }

      let form = { ...that.form }
      form = that.removeObjectNull(form)
      form.detailList = that.removeArrayNull(form.detailList)

      const { data: res } = await that.$http.post('/Finance/Report_approve', form)
      if (res.isSuccess) {
        that.id = res.data
        that.$emit('updateData')

        this.$refs.FileListRef.handleUploadCacheFileToDB() // 提交缓存附件

        that.BindText()
        that.$message.success(that.messageConfig.save.success)
      } else {
        that.$message.error(res.errorMessage)
      }
    },
    // 更新
    async update() {
      const that = this
      let form = { ...that.form }
      form = that.removeObjectNull(form)
      form.detailList = [...form.detailList, ...this.cacheRemoveRows]
      form.detailList = that.removeArrayNull(form.detailList)

      const { data: res } = await that.$http.put('/Finance/Report_approve', form)
      if (res.isSuccess) {
        that.$message.success(that.messageConfig.save.success)
        that.$emit('updateData')

        that.BindText()
      } else {
        that.$message.error(res.errorMessage)
      }
    },
    // 删除
    del() {
      const that = this
      this.$confirm('此操作将永久删除该单据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const { data: res } = await that.$http.delete('/Finance/Report_approve', {
          data: {
            id: that.id
          }
        })
        if (res.isSuccess) {
          that.$message.success(that.messageConfig.del.success)
          that.formVisible = false

          that.$emit('updateData')
        } else {
          that.$message.error(res.errorMessage)
        }
      })
    },
    // 提交缓存文件
    submitCacheFileToServer() {
      // this.$refs.FileListRef.handleUploadCacheFileToDB()
    },
    // 大写金额转换
    convertCurrency(amount) {
      if (amount == null || amount == '') {
        return ''
      }
      return this.amountLtoU(amount)
    },
    showModal() {
      this.BindText()

      this.getFileList()
    },
    // table 点击删除列
    removeRowForTableCustom(row, rowIndex) {
      this.$confirm('确定要删除本行吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          // 处理数据
          if (row.id && row.id > 0) {
            this.cacheRemoveRows.push({
              ...row,
              id: 0 - row.id
            })
          }

          // 删除
          this.form.detailList.splice(rowIndex, 1)

          this.IfExistModify = true
        })
        .catch(() => {})
    }
  },
  computed: {
    // 获取状态
    DocumentStatus() {
      if (this.id === 0) {
        return ''
      }

      return `[${getState(this.form, 'ReportApprove')}] `
    },
    tableColumns() {
      let tableColumns = [
        {
          type: 'seq',
          width: '50',
          className: 'seqErrorVaildClass',
          slots: {
            default: ({ row }) => {
              if (row.ifRepeat) {
                return [
                  <el-tooltip class='tooltipItem' effect='light' content={row.repeatText} placement='right'>
                    <div style='width: 100%; height: 100%'>
                      <span>{this.$refs.xTable.getVTRowIndex(row) + 1}</span>
                    </div>
                  </el-tooltip>
                ]
              } else {
                return [<span>{this.$refs.xTable.getVTRowIndex(row) + 1}</span>]
              }
            }
          }
        }
      ]

      // 禁用
      if (!this.isDisabled) {
        tableColumns.push({
          field: 'delete',
          title: '删除',
          width: '50',
          visible: this.isCanEdit,
          align: 'center',
          slots: {
            default: ({ row, rowIndex }) => {
              return [
                <i
                  id='vxeDelete'
                  class='el-icon-delete-solid'
                  onClick={() => {
                    this.removeRowForTableCustom(row, rowIndex)
                  }}
                ></i>
              ]
            }
          }
        })
      }

      tableColumns = [
        ...tableColumns,
        ...[
          {
            field: 'sender',
            title: '寄件人',
            editRender: { name: '$input', attrs: { disabled: true } },
            slots: {
              header: ({ column }) => {
                return [
                  <span>
                    {column.title}
                    &nbsp;
                    <i class='iconfont col-iconfont fjyk-mouseR' />
                  </span>
                ]
              }
            }
          },
          {
            field: 'ship_date',
            title: '寄件日期',
            formatter: ['formatDate', 'yyyy-MM-dd'],
            editRender: { name: '$input', attrs: { disabled: true } },
            slots: {
              header: ({ column }) => {
                return [
                  <span>
                    {column.title}
                    &nbsp;
                    <i class='iconfont col-iconfont fjyk-mouseR' />
                  </span>
                ]
              }
            }
          },
          {
            field: 'contribution_details',
            title: '寄件内容',
            editRender: { name: 'input' },
            slots: {
              header: ({ column }) => {
                return [
                  <span>
                    {column.title}
                    &nbsp;
                    <i class='iconfont col-iconfont fjyk-tianxie' />
                  </span>
                ]
              }
            }
          },
          {
            field: 'courier_company',
            title: '快递公司',
            editRender: { name: 'input' },
            slots: {
              header: ({ column }) => {
                return [
                  <span>
                    {column.title}
                    &nbsp;
                    <i class='iconfont col-iconfont fjyk-tianxie' />
                    &nbsp;
                    <i class='iconfont col-iconfont fjyk-mouseR' />
                  </span>
                ]
              }
            }
          },
          {
            field: 'is_expedited',
            title: '是否加急',
            editRender: { name: '$input', attrs: { disabled: true } },
            slots: {
              header: ({ column }) => {
                return [
                  <span>
                    {column.title}
                    &nbsp;
                    <i class='iconfont col-iconfont fjyk-mouseR' />
                  </span>
                ]
              }
            }
          },
          {
            field: 'receiving_company',
            title: '收件单位',
            editRender: { name: 'input' },
            slots: {
              header: ({ column }) => {
                return [
                  <span>
                    {column.title}
                    &nbsp;
                    <i class='iconfont col-iconfont fjyk-tianxie' />
                    &nbsp;
                    <i class='iconfont col-iconfont fjyk-mouseR' />
                  </span>
                ]
              }
            }
          },
          {
            field: 'recipient',
            title: '收件人',
            editRender: { name: 'input' },
            slots: {
              header: ({ column }) => {
                return [
                  <span>
                    {column.title}
                    &nbsp;
                    <i class='iconfont col-iconfont fjyk-tianxie' />
                    &nbsp;
                    <i class='iconfont col-iconfont fjyk-mouseR' />
                  </span>
                ]
              }
            }
          }
        ]
      ]

      return tableColumns
    }
  }
}
</script>
<style lang="less" scoped>
@rightFormContainerWidth: 250px;

.bottomBtns {
  display: flex;
  justify-content: center;
  margin-top: 10px;
}
.formContainer {
  height: calc(100% - 40px - 10px - 31px);
  display: flex;
  flex-wrap: wrap;
}
.el-form-item {
  // margin: 0px !important;
  width: 100%;
  .el-input,
  .el-select,
  .el-date-picker {
    width: 100%;
  }
}
.leftFormContainer {
  height: 100%;
  width: calc(100% - @rightFormContainerWidth);

  box-sizing: border-box;
  padding: 0 10px 10px 10px;

  overflow: auto;

  /* 修改滚动条的宽度和颜色 */
  &::-webkit-scrollbar {
    width: 10px;
  }

  &::-webkit-scrollbar-track {
    background-color: #f1f1f1;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #999;
  }

  /* 鼠标悬停时滚动条 thumb 的颜色 */
  &::-webkit-scrollbar-thumb:hover {
    background-color: #888;
  }
}
.rightFormContainer {
  height: 100%;
  width: @rightFormContainerWidth;
  box-sizing: border-box;
  padding: 0 10px;
}

.el-autocomplete {
  width: 100%;
}
</style>
